import { getFileHash } from '@/lib/getFileHash';
import { transferSnakeToCamel, snakeToCamel } from '@/lib/utils';
import { WrapResponse } from '@/types';
import { api } from '@/lib/env';
import { fun } from '@/lib/request';
import { Col, ColData, FileInfo, PaperFileData } from './paperTypes';



// 获取文件hash等信息
export const getFileInfo = async (file: File): Promise<FileInfo> => {
  const md5 = await getFileHash(file, 'MD5');
  const sha1 = await getFileHash(file, 'SHA1');
  const id = `${md5}${sha1}`;
  return ({
    id,
    md5,
    sha1,
    filename: file.name,
  })
};

// ColData转Col
export const colDataToCol = (colData: ColData[]): Col[] => {
  if (!colData?.length) {
    return [];
  }
  return colData.map(({
    name,
    colKey,
    custom,
    selected,
    refBtnShow: expired,
    colDesc,
    isCustom,
    ...rest
  }) => ({
    name,
    key: transferSnakeToCamel(colKey),
    selected: selected ?? custom === 1,
    desc: colDesc,
    expired,
    isCustom,
    ...rest
  }));
}


// 绑定上传hash
export const bindUploadByHash = async (subjectId: string, files: FileInfo[], ignoreAiCol?: boolean) => {
  try {
    const formData = new FormData();
    formData.append('subject_id', subjectId);
    files.forEach((data, i) => {
      formData.append(`files[${i}][md5]`, data.md5);
      formData.append(`files[${i}][sha1]`, data.sha1);
      formData.append(`files[${i}][filename]`, data.filename);
    })
    if (ignoreAiCol) {
      formData.append('ignore_ai_col', ignoreAiCol ? '1' : '0');
    }
    const { code, message, data } = (
      await fun.post<WrapResponse<PaperFileData[]>>(
        api('/paper/upload/uploadByHash', true),
        formData
      )).data;
    const paperFiles = snakeToCamel<PaperFileData[]>(data);
    return { code, data: paperFiles, message };
  } catch (error) {
    console.error('Error explain references:', error);
    return null;
  }
}